import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from "@/views/LoginView.vue";
import IndexView from "@/views/IndexView.vue";
import UserView from "@/views/user/UserView.vue";
import MenuView from "@/views/menu/MenuView.vue";
import ConfigView from "@/views/config/ConfigView.vue";
import NoticeView from "@/views/notice/NoticeView.vue";
import ProductView from "@/views/product/ProductView.vue";
import supervisionView from "@/views/SupervisionView.vue";
import ShowView from "@/views/ShowView.vue";
import SupplyView from "@/views/supply/SupplyView.vue";
import sourceView from "@/views/SourceView.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        // eslint-disable-next-line no-sparse-arrays
        children: [
            {
                path: '/index',
                name: 'index',
                component: IndexView
            },
            {
                path: '/user',
                name: 'user',
                component: UserView
            },
            {
                path: '/menu',
                name: 'menu',
                component: MenuView
            }, {
                path: '/config',
                name: 'config',
                component: ConfigView
            },
            {
                path: '/notice',
                name: 'notice',
                component: NoticeView
            },
            {
                path: '/product',
                name: 'product',
                component: ProductView
            },
            {
                path: '/supply',
                name: 'supply',
                component: SupplyView
            }
        ]
    },
    {
        path: '/',
        name: 'login',
        component: LoginView
    },
    {
        path: '/supervision',
        name: 'supervision',
        component: supervisionView
    },
    {
        path: '/show',
        name: 'show',
        component: ShowView
    },
    {
        path: '/source',
        name: 'source',
        component: sourceView
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
